import { meApi } from '@/lib/api';
import { isSettingsShortcut } from '@/lib/settings-shortcut';
import { useQuery } from '@tanstack/react-query';
import { useLocation, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

/**
 * Invisible: listens for Ctrl/Cmd+Shift+. and opens `/settings` for a real
 * `pms_user` / `pms_admin` (the real role, so a role simulation cannot take the
 * shortcut away). Does nothing for the client roles, nothing when already on
 * the page, and leaves `/login` to the Tahiti encart, which owns the shortcut
 * there. Mounted once in `__root.tsx`.
 */
export function SettingsShortcut() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const onLogin = pathname === '/login';
  const { data: user } = useQuery({
    queryKey: ['me'],
    queryFn: () => meApi.get(),
    enabled: !onLogin,
  });
  const allowed = user?.role === 'pms_user' || user?.role === 'pms_admin';
  const onSettings = pathname === '/settings';

  useEffect(() => {
    if (onLogin || onSettings || !allowed) return;
    function onKey(event: KeyboardEvent): void {
      if (!isSettingsShortcut(event)) return;
      event.preventDefault();
      void navigate({ to: '/settings', search: { tab: 'affichage' } });
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onLogin, onSettings, allowed, navigate]);

  return null;
}
